// extracted by mini-css-extract-plugin
export default {"container":"Catalogue_container__J7wY0","section-list":"Catalogue_section-list__TyfZ1","section-categories":"Catalogue_section-categories__5Hr93"};